import { useContext } from "react";
import { ShowContent } from "../../../components";
import AuthContext from "../../../context/AuthContext";
import { ProposalClient } from "./ProposalClient";
import { ProposalAdmin } from "./ProposalAdmin";

export const ProposalPage = () => {
  const { idRole, isLoading } = useContext(AuthContext);

  const content = idRole === 3 ? <ProposalClient /> : <ProposalAdmin />;

  return <ShowContent error={""} isLoading={isLoading} content={content} />;
};
